import { useEffect, useState } from 'react';
import { getPickupLocations } from '../../services/cards';

export const usePickupLocations = (params?: { city?: string; state?: string; country?: string; include_all?: boolean; next_cursor?: string }) => {
  const [locations, setLocations] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    getPickupLocations(params || {})
      .then((res) => {
        setLocations(res.addresses || []);
        setError(null);
      })
      .catch((err) => {
        setError(err.message || 'Failed to fetch pickup locations');
        setLocations([]);
      })
      .finally(() => setLoading(false));
  }, [JSON.stringify(params)]);

  return { locations, loading, error };
}; 